<ng-container *ngIf="pagination.totalItems > 0 else nodata">
    <div class="children-container" *ngIf="tableView$ | async as tableView">
        <ng-container *ngIf="tableView.loading === false && tableView.hasError === false ">
        <lib-table
            [dataSummary]="tableView.tableSummary "
            [tableColumns]="tableColumns"
            [pagination]="pagination"
            [displayFilterButtons]="false"
            [displayRefreshButtons]="false"
            [displaySearchInput]="false"
            [searchPlaceholder]="'search.search' | translate"
            [hasRowExpansion]="false"
            [displayCaption]="false"
            (paginationChange)="onPageChange($event)"
            (sortChange)="onSortChange($event)"
        >
    </lib-table>
        </ng-container>

    </div>

</ng-container>

<ng-template #nodata>
    <ng-container *ngIf="!loading">
        <p class="no-data-container">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span>{{'dialog-message.noExportRequestChildrenFound' | translate}} </span>
        </p>
    </ng-container>
</ng-template>
